import FormikDatePicker from 'components/common/Fields/FormikDatePicker';
import { Field, Formik } from 'formik';
import React, { useState } from 'react'
import Calendar from 'assets/icon/calendar-icon.svg';
import { dateFormate } from 'utils/columns';
import { Button, Card, CardBody, Col, Container, FormGroup, Input, InputGroup, InputGroupText, Label, Row } from 'reactstrap';
import NDCList from 'components/NDCList';
import ChargeCodeList from 'components/ChargeCodeList';
import moment from 'moment';
import useAxios from 'hooks/useAxios';
import { toast } from 'react-toastify';
import DatePicker from 'react-datepicker';
import Loader from 'components/Loader';
import NDCLISTINPUT from 'components/NDCLISTINPUT';
import cancel from "assets/icon/cancel.svg";
import search from "assets/icon/search.svg";
import save from "assets/icon/save.svg";
import ReactInputMask from "react-input-mask";


let hasDatePopupOpen = false;


let chargecodeerror = 'Charge Code is a required field'
let chargediscerror = 'Charge Description is a required field'
let bupperror = 'BUPP is a required field'
let stdateerror = 'Effective Date is a required field'
let endDateError = "Term Date must be Greater Than or Equal to EffectiveDate";
let ndcerror = 'NDC is a required field'
let ndcDiscerror = 'NDC Description is a required field'
let packageerror = 'Package Size is a required field'
let dataflag = false;
//let Dosflag = false;
let hiddenndcmsg = 'The chosen NDC is in hidden status, please unhide the NDC before proceeding with mapping.'
let hiddenchargemsg = 'The Charge code you are trying to map is in hidden status. Please unhide the charge code to proceed with mapping.'
let mapmsg = 'Due to current automapping status, mapping must be completed through the M icon in the main crosswalk.'
let validationarrmsg = [mapmsg, hiddenndcmsg]
const AddCrosswalkDrawer = ({ orgId, searchTerms, addCrosswalk,storedDate}) => {
    const API = useAxios();
debugger;
    const [startDate, setstartDate] = useState(null);
    const [termdate, setTermDate] = useState(null);
    const [minstartDate, setMinstartDate] = useState(null);
    const [selectedNdc, setSelectedNdc] = useState('');
    const [chargeDisc, setChargeDisc] = useState('');
    const [ndcDisc, setNdcDisc] = useState('');
    const [ndcpkg, setNDCPackage] = useState('');
    const [provider, setProvider] = useState('');
    const [dosflag, setDosflag] = useState(false);
    const [bupp, setBupp] = useState(0);
    const [notes, setNotes] = useState('');
    const [err, setErr] = useState('');
    const [error, seterror] = useState(false);
    const [loader, setLoader] = useState(false);
   // const [hiddenCheck,setHiddenCheck] = useState('');

    const handleDateClick = (id) => {
        if (hasDatePopupOpen) {
            hasDatePopupOpen = false;
            return;
        }
        const calendarButton = document.getElementById(id);
        if (calendarButton) {
            calendarButton.click();
            hasDatePopupOpen = true;
        }
    };
    const handleMouseLeave = () => {
        hasDatePopupOpen = false;
    };

    const handleStartDate = (startDate) => {
        // let stDate = startDate.toISOString();
        // //      let dt =  stDate.substring(0,10)
        // //    // var dt = moment(stDate, "MM/DD/YYYY", true);
        setstartDate(new Date(startDate));

        if (error == false) {
            seterror(false);

        }
        //  seterror(false);

    };
    const fetchChargecodeCheck = async (chargeCode) => {
    debugger;
    setLoader(true);
      let accid = searchTerms.AccumulatorID;
    try {
      const { data } = await API.get(
        `SBTenant/${orgId.tenantID}/CrossWalk/HiddenChargeCodeCheck/${chargeCode}/${accid}`,
        {
          hasDefaultURL: true,
        }
      );
      debugger
      if (data?.error == true) {
        setErr(data.message)
      }
      else{
          setErr('');
       }
      setLoader(false);
    } catch {
      setLoader(false);
    }
  };
    const fetchHiddenNDCCheck = async (ndc) => {
    debugger;
    setLoader(true);
    let accid = searchTerms.AccumulatorID;
    try {
      const { data } = await API.get(
        `SBTenant/${orgId.tenantID}/CrossWalk/HiddenNDCCheck/${ndc}/${accid}`,
        {
          hasDefaultURL: true,
        }
      );
      debugger
      if (data?.error == true) {
        setErr(data.message)
      }
      else {
        setErr('');
      }
      setLoader(false);
    } catch {
      setLoader(false);
    }
  };
    const handletermdate = (e) => {
        debugger;
        if (e == null) {
            setTermDate(null);
        } else {
            setTermDate(new Date(e));
        }

    };

    // const handleNdc = (ndc, setFieldValue) => {
    //     debugger;
    //     if (ndc !== null) {
    //         setSelectedNdc(ndc);
    //         setNdcDisc(ndc.description);
    //         seterror(false);
    //     }
    //     else {
    //         setSelectedNdc(null);
    //         setNdcDisc('');
    //         setErr('');
    //     }

    // };

    const fetchdate = async (provider) => {
        setLoader(true);
        let acid = acid = searchTerms.AccumulatorID;
        try {

            const { data } = await API.get(`SBTenant/${orgId.tenantID}/CrossWalk/GetDate/${provider.code}/${acid}`,
                { hasDefaultURL: true, }
            )
            if (data.message == "UnmappedChargecode") {
                let newDate = new Date(data.startDate);
                //setstartDate(newDate);
                setstartDate(null);
                setMinstartDate(newDate);
                dataflag = true;
                setLoader(false);
                return true;
            }
            if (data.message == "HiddenChargeCode") {
                //setstartDate(newDate);
                setstartDate(null);
                setErr('The Charge code you are trying to map is in hidden status. Please unhide the charge code to proceed with mapping.')
                setLoader(false);
                return true;
            }
            if (data.message == "UnmappedChargecodewithEnddate") {
                let newDate = new Date(data.startDate);
                newDate.setDate(newDate.getDate() + 1);
                //setstartDate(newDate);
                setstartDate(null);
                setMinstartDate(newDate);
                dataflag = false;
                setLoader(false);
                return true;
            }
            if (data.message == "DOS Out Of Range") {
                let newDate = new Date(data.startDate);
                setstartDate(newDate)
                setMinstartDate(newDate);
                setDosflag(true);
                setLoader(false);
                return true
            };
            if (data.startDate == null) {
                //setstartDate(newDate);
                setstartDate(null);
                setMinstartDate(null);
                setLoader(false);
                dataflag = true;
            }
            else {
                let newDate = new Date(data.startDate);
                newDate.setDate(newDate.getDate() + 1);
                //setstartDate(newDate);
                setstartDate(null);
                setMinstartDate(newDate);
                dataflag = false;
                setLoader(false);
                return true

            }

        }
        catch {
            setLoader(false);
        }
    }
    const onSelect = async (chargecode) => {
debugger
        // setErr('');
        if (chargecode) {
            setProvider(chargecode);
            setChargeDisc(chargecode.description);
           // fetchdate(chargecode);
            fetchChargecodeCheck(chargecode.code)
            if (error == false) {
                seterror(false);
            }
        } else {
            setProvider('');
            setChargeDisc('');
            setstartDate(null);
           // setHiddenCheck('')
            // if(selectedNdc == ''){
            //     setErr('');
            // }
            if (err == hiddenchargemsg) {
                setErr('');
            }

        }

    };
    const fetchvalidations = async (ndc) => {

        let accid = searchTerms.AccumulatorID;

        setLoader(true);
        try {
            const { data } = await API.get(`SBTenant/${orgId.tenantID}/Crosswalk/Getvalidations/${ndc}/${accid}`, {
                hasDefaultURL: true,
            });

            if (data.error == true) {
                setErr(data.message)
                setLoader(false);
                return true;
            }
            else {
                setLoader(false);
            }
        } catch {
            setLoader(false);
        }
    }
    const onSelectndc = async (ndc) => {
        debugger;
        // setErr('');
        if (ndc) {
            setSelectedNdc(ndc);
            setNdcDisc(ndc.description);
            setNDCPackage(ndc.packageSize);
            fetchHiddenNDCCheck(ndc.code)
           // fetchvalidations(ndc.code)
            // seterror(false);
            if (error == false) {
                seterror(false);

            }
        } else {
            setSelectedNdc('');
            setNdcDisc('');
            setNDCPackage('');
          //  setHiddenCheck('')
            // if(provider == ''){
            //     setErr('');
            // }
            if (validationarrmsg.includes(err)) {
                setErr('');
            }


        }

    };

    // const validations = ()=>{
    //     if(provider.code == null || selectedNdc.id ==  0 || provider.description == null || bupp == 0 || startDate == null ){
    //      return  seterror(true);

    //     }

    //}
    const handleSubmit = async () => {
        debugger;
        setLoader(true);
        if (provider.code == null || (selectedNdc.code == '' || selectedNdc.code == undefined) || chargeDisc == '' || bupp == 0 || startDate == null || ndcDisc == '' || (termdate != null && (new Date(termdate) < new Date(startDate)))) {
            setLoader(false);
            return seterror(true);

        }
        else {
            let payload = {};
            payload.Chargecode = provider.code;
            payload.NDC = selectedNdc.code;
            payload.ChargeDescription = chargeDisc != "" ? chargeDisc : provider.description;
            payload.PackageSize = ndcpkg;
            payload.BUPP = bupp;
            payload.AccumulatorID = searchTerms.AccumulatorID;
            payload.Notes = notes;
            payload.DrugDescription = ndcDisc;
            payload.StartDate = moment(startDate, "MM/DD/YYYY").format("YYYY-MM-DD[T]HH:mm:ss");
            if (termdate != null) {
                payload.EndDate = moment(termdate, "MM/DD/YYYY").format("YYYY-MM-DD[T]HH:mm:ss");
            }
            else {
                payload.EndDate = null;
            }
            payload.ChargeID = 0;
            try {
                const { data } = await API.post(`SBTenant/${orgId.tenantID}/CrossWalk/NewMapping`, payload,
                    { hasDefaultURL: true, }
                )
                if (data.error == true) {

                    setErr(data.message)
                    // toast.error(data.message);
                    setLoader(false);
                    addCrosswalk();
                }
                else {
                    setLoader(false);
                    toast.success(data.message);
                    addCrosswalk(true);

                }
            }
            catch {
                setLoader(false);
            }
        }
    }
    const handlechargedisc = (e) => {
        setChargeDisc(e.target.value);
        if (error == false) {
            seterror(false);

        }
        // seterror(false);
    }
    const handleEffectiveDateRaw = (e) => {
        debugger;
        var val = e.target.value;
        var dt = moment(val, "MM/DD/YYYY", true);
        var isValid = dt.isValid();
        if (isValid == false && startDate !== null) {
            setstartDate(null);
        }
        if (isValid) {
            handleStartDate(e.target.value);
        }
    };
    const handleNDcDisc = (e) => {
        setNdcDisc(e.target.value);
        if (error == false) {
            seterror(false);
        }

        //seterror(false);
    }
    const handleNDcPkg = (e) => {
        setNDCPackage(e.target.value);
        if (error == false) {
            seterror(false);
        }
    }
    const handlebupp = (e) => {
        setBupp(e.target.value);
        if (error == false) {
            seterror(false);
        }
        //seterror(false);
    }
    return (
        <div>
            <Formik
                initialValues={''}
                onSubmit={handleSubmit}
                // validationSchema={validationSchema}
                // enableReinitialize={true}
                children={(props) => {
                    const { isSubmitting, handleSubmit, resetForm, setFieldValue, errors, touched } = props;
                    return (
                        <div className='addcrooswalk'>
                            <Row>
                                <Col md={1}>
                                    &nbsp;
                                </Col>
                                <Col md={3}>
                                    <Label style={{ marginTop: 11, float: 'right' }}>Charge Code</Label>
                                </Col>
                                <Col md={6}><ChargeCodeList tenantID={orgId.tenantID}
                                    onSelect={onSelect}
                                    selectedProvider={provider}
                                    acid={searchTerms.AccumulatorID}
                                    crosswalkadd={true} />
                                </Col>

                            </Row>
                            <Row>
                                <Col md={4}>
                                    &nbsp;
                                </Col>
                                <Col md={6}>
                                    {(error && provider.code == null) ? (
                                        <div className="text-danger f-12" style={{ fontWeight: 'bold' }}>
                                            {chargecodeerror}
                                        </div>
                                    ) : null}
                                </Col>
                            </Row>
                            <Row>
                                <Col md={1}>
                                    &nbsp;
                                </Col>
                                <Col md={3}>
                                    <Label style={{ marginTop: 11, float: 'right' }}>Charge Description</Label>
                                </Col>
                                <Col md={6}><Input type='text' className='required' value={chargeDisc} onChange={handlechargedisc} />
                                </Col>


                            </Row>
                            <Row>
                                <Col md={4}>
                                    &nbsp;
                                </Col>
                                <Col md={6}>
                                    {(error && chargeDisc == "") ? (
                                        <div className="text-danger f-12" style={{ fontWeight: 'bold' }}>
                                            {chargediscerror}
                                        </div>
                                    ) : null}
                                </Col>
                            </Row>
                            {/* <Row>
                                <Col md={1}>
                                    &nbsp;
                                </Col>
                                <Col md={3}>
                                    <Label style={{ marginTop: 11, float: 'right' }}>NDC</Label>
                                </Col>
                                <Col md={6}><NDCList
                                    name="ndc"
                                    onSelect={(value) => handleNdc(value, setFieldValue)}
                                    selectedNDC={selectedNdc}
                                />
                                   </Col>

                            </Row> */}
                            <Row>
                                <Col md={1}>
                                    &nbsp;
                                </Col>
                                <Col md={3}>
                                    <Label style={{ marginTop: 11, float: 'right' }}>NDC</Label>
                                </Col>
                                <Col md={6}><NDCLISTINPUT
                                    name="ndc"
                                    onSelect={onSelectndc}
                                    selectedProvider={selectedNdc}
                                />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    &nbsp;
                                </Col>
                                <Col md={6}>
                                    {(error && (selectedNdc.code == '' || selectedNdc.code == undefined)) ? (
                                        <div className="text-danger f-12" style={{ fontWeight: 'bold' }}>
                                            {ndcerror}
                                        </div>
                                    ) : null}
                                </Col>
                            </Row>
                            <Row>
                                <Col md={1}>
                                    &nbsp;
                                </Col>
                                <Col md={3}>
                                    <Label style={{ marginTop: 11, float: 'right' }}>NDC Description</Label>
                                </Col>
                                <Col md={6}><Input type='text' className='required' value={ndcDisc} onChange={handleNDcDisc} />
                                </Col>


                            </Row>
                            <Row>
                                <Col md={4}>
                                    &nbsp;
                                </Col>
                                <Col md={6}>
                                    {(error && (ndcDisc == '')) ? (
                                        <div className="text-danger f-12" style={{ fontWeight: 'bold' }}>
                                            {ndcDiscerror}
                                        </div>
                                    ) : null}
                                </Col>
                            </Row>
                            <Row>
                                <Col md={1}>
                                    &nbsp;
                                </Col>
                                <Col md={3}>
                                    <Label style={{ marginTop: 11, float: 'right' }}>Package Size</Label>
                                </Col>
                                <Col md={6}><Input type='text' disabled className='required' value={ndcpkg} onChange={handleNDcPkg} />
                                </Col>


                            </Row>
                            <Row>
                                <Col md={4}>
                                    &nbsp;
                                </Col>
                                <Col md={6}>
                                    {(error && (ndcDisc == '')) ? (
                                        <div className="text-danger f-12" style={{ fontWeight: 'bold' }}>
                                            {packageerror}
                                        </div>
                                    ) : null}
                                </Col>
                            </Row>
                            <Row>
                                <Col md={1}>
                                    &nbsp;
                                </Col>
                                <Col md={3}>
                                    <Label style={{ marginTop: 11, float: 'right' }}>BUPP</Label>
                                </Col>
                                <Col md={6}><Input type='text' className='required' name='bupp' maxLength={15} onChange={handlebupp} />
                                </Col>

                            </Row>

                            <Row>
                                <Col md={4}>
                                    &nbsp;
                                </Col>
                                <Col md={6}>
                                    {(error && bupp == 0) ? (
                                        <div className="text-danger f-12" style={{ fontWeight: 'bold' }}>
                                            {bupperror}
                                        </div>
                                    ) : null}
                                </Col>
                            </Row>
                            {loader && <Loader />}
                            <Row>
                                <Col md={1}>
                                    &nbsp;
                                </Col>
                                <Col md={3}>
                                    <Label style={{ marginTop: 11, float: 'right' }}>Effective Date</Label>
                                </Col>
                                <Col md={6} className='purchase-date-addcrosswalk'>
                                    <FormGroup>
                                        <InputGroup onMouseLeave={handleMouseLeave} className='required'>
                                            <DatePicker
                                                type="date"
                                                id="startDate"
                                                selected={startDate}
                                                onChange={handleStartDate}
                                                placeholderText='select a date'
                                                name="startDate"
                                                disabled={dosflag}
                                                onChangeRaw={handleEffectiveDateRaw}
                                                autoComplete="off"
                                                dateFormat="MM/dd/yyyy"
                                              
                                                onKeyDown={(e) => e.preventDefault()}
                                                // customInput={
                                                //     <ReactInputMask
                                                //         mask="99/99/9999"
                                                //         //  minDate={new Date(orderDate)}
                                                //         //minDate={new Date(storedDate)}
                                                //         value={startDate}
                                                //     />
                                                // }
                                                minDate={new Date(storedDate)}
                                                // minDate={dataflag == true ? false :
                                                //     new Date(minstartDate)}
                                                // placeholderText={placeholder}
                                                className="border-0 w-100 date-picker "
                                            />
                                            <InputGroupText
                                                onClick={() => handleDateClick("startDate")}
                                            >
                                                <img src={Calendar} alt="" />
                                            </InputGroupText>
                                        </InputGroup>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    &nbsp;
                                </Col>
                                <Col md={6}>
                                    {(error && startDate == null) ? (
                                        <div className="text-danger f-12" style={{ fontWeight: 'bold' }}>
                                            {stdateerror}
                                        </div>
                                    ) : null}
                                </Col>
                            </Row>
                            <Row>
                                <Col md={1}>
                                    &nbsp;
                                </Col>
                                <Col md={3}>
                                    <Label style={{ marginTop: 11, float: 'right' }}>Term Date</Label>
                                </Col>
                                <Col md={6} className="notrequired-date-endDate-crosswalk scroll-index">
                                    <FormGroup>
                                        <InputGroup onMouseLeave={handleMouseLeave} className="required">
                                            <DatePicker
                                                type="date"
                                                id="termdate"
                                                selected={termdate}
                                                onChange={handletermdate}
                                                placeholderText="select a date"
                                                name="termdate"
                                                openToDate={startDate != null ? new Date(startDate) : false}
                                                minDate={startDate != null ? new Date(startDate) : false}
                                                // onChangeRaw={handleTermDateRaw}
                                                dateFormat="MM/dd/yyyy"
                                                onKeyDown={(e) => e.preventDefault()}
                                                autoComplete="off"
                                                className="border-0 w-100  "
                                                isClearable
                                            />
                                            <InputGroupText
                                                onClick={() => handleDateClick("termdate")}
                                            >
                                                <img src={Calendar} alt="" />
                                            </InputGroupText>
                                        </InputGroup>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    &nbsp;
                                </Col>
                                <Col md={6}>
                                    {termdate != null && (termdate < startDate) ? (
                                        <div className="text-danger f-12" style={{ fontWeight: 'bold' }}>
                                            {endDateError}
                                        </div>
                                    ) : null}
                                </Col>
                            </Row>
                            <Row>
                                <Col md={1}>
                                    &nbsp;
                                </Col>
                                <Col md={3}>
                                    <Label style={{ marginTop: 11, float: 'right' }}>Comments</Label>
                                </Col>
                                <Col md={6}><Input type='textarea' name='notes' onChange={(e) => setNotes(e.target.value)} /></Col>
                            </Row>
                            {err && (
                                <div className="text-danger f-12" style={{ fontWeight: 'bold' }}>
                                    {err}
                                </div>
                            )}
                            <Row>

                            </Row>
                       
                            <Row>
                                <Col md={4}>
                                    &nbsp;
                                </Col>
                                <Col md={12} style={{ display: "flex", justifyContent: "flex-end" }}>
                                    <div>
                                        <div className="mt-3">
                                            <Button color="primary" className="search" onClick={handleSubmit} disabled={err !== ''} >
                                                <span className="right_5"><img src={save} alt="" /></span>
                                                {" "}Save
                                            </Button>{" "}
                                            <Button color="primary" className="reset" onClick={addCrosswalk}>
                                                <span className="right_5"><img src={cancel} alt="" /></span>
                                                {" "}Cancel
                                            </Button>
                                        </div>
                                    </div>

                                </Col>
                            </Row>
                        </div>
                    )
                }}></Formik>
        </div>
    )
}

export default AddCrosswalkDrawer